import React, { useCallback, useState } from 'react';
import { useDialogTree } from '../context';

import DialogTreeComponent from '../index';
import DeleteNodeConfirmationModal from '../../components/deleteNodeConfirmationModal';
import { loopTreeData } from '../context/helpers';
import { button_style } from 'views/IVR/form/tree/node/styles';
import { delete_icon_style } from 'views/IVR/form/tree/node/styles';
import { add_icon_style } from 'views/IVR/form/tree/node/styles';
import { MdEdit, MdOutlineCircle } from 'react-icons/md';

const nameStyle = {
  fontSize: '0.8rem',
  fontFamily: 'Open Sans, sans-serif',
  fontSize: '1rem',
  fontWeight: '400',
  lineHeight: '1.5',
  color: '#525f7f',
  textAlign: 'left'
};

const NodeTree = ({ nodeData }) => {
  const { openModal, treeData, availableQueues, nodeActions } = useDialogTree();

  const hasData = Object.values(nodeData.action).length > 0;

  const [modalExcludeNode, setModalExcludeNode] = useState(false);

  const verifyIfNodeHasChildren = useCallback(() => {
    return nodeData.nodes && Object.keys(nodeData.nodes).length > 0;
  }, [nodeData]);

  const getNodeName = () => {
    if (!isTheDefaultNode()) {
      return nodeData?.numericIdentifier
        ? `${nodeData.numericIdentifier} - ${nodeData.stringIdentifier}`
        : nodeData.stringIdentifier;
    } else {
      return 'Nó Padrão';
    }
  };

  const descriptionNodeStyle = {
    fontStyle: 'italic',
    position: 'absolute',
    bottom: '8px',
    left: '8px',
    fontSize: '0.9rem',
    color: '#565656'
  };

  const isTheDefaultNode = () => {
    return nodeData.isDefault ? true : false;
  };

  const handleNodeActions = (action) => {
    switch (action) {
      case 'ADD_NEW_NODE':
        openModal(nodeData, 'ADD_NEW_NODE');
        break;
      case 'ADD_NEW_NODE_CHILD':
        openModal(nodeData, 'ADD_NEW_NODE_CHILD');
        break;
      case 'EDIT_NODE':
        openModal(nodeData, 'EDIT_NODE');
        break;
      case 'DELETE_NODE':
        setModalExcludeNode(true);
        break;
      default:
        break;
    }
  };

  const shouldShowAddButton = () => {
    if (!nodeData?.attributes) return true;
    if (!nodeData?.attributes?.content) return true;
    if (nodeData?.attributes?.content?.substring(0, 5) === 'Áudio') return true;
    return false;
  };

  const shoudShowDeleteButton = () => {
    if (nodeData.depth !== 0 && !nodeData.children && !nodeData.isDefault) {
      return true;
    }
    return false;
  };

  const getActionName = () => {
    if (!nodeData?.action?.type || !nodeActions.length) return '';

    const action = nodeActions.find(
      (action) => action.type === nodeData.action.type
    );

    if (!action) return '';

    return action.description;
  };

  return (
    <>
      <div style={{ width: '100%', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            height: '110px',
            width: '230px',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            padding: '5px 12px 5px 12px',
            flexDirection: 'column',
            borderRadius: '12px',
            boxShadow: 'rgba(0, 0, 0, 0.23) 4px 6px 6px 0px',
            background: '#cbe8c9'
          }}
        >
          {(hasData || isTheDefaultNode()) && (
            <button
              type="button"
              style={{
                ...button_style,
                position: 'absolute',
                left: '211px',
                bottom: shoudShowDeleteButton() ? '32px' : '13px',
                scale: '0.7'
              }}
              onClick={() => openModal(nodeData, 'EDIT_NODE')}
            >
              <i style={{}} className="fas fa-edit"></i>
            </button>
          )}

          {nodeData.depth !== 0 && !nodeData.children && !nodeData.isDefault && (
            <i
              className="far fa-times-circle"
              style={{
                ...delete_icon_style,
                bottom: shouldShowAddButton() ? '40px' : '20px',
                left: '219px',
                borderRadius: '14px',
                background: '#cbe8c9'
              }}
              onClick={() => {
                handleNodeActions('DELETE_NODE');
              }}
            ></i>
          )}

          {shouldShowAddButton() && (
            <i
              className="fas fa-plus-circle"
              style={{
                ...add_icon_style,
                left: '219px',
                bottom: '20px',
                borderRadius: '14px',
                background: 'white'
              }}
              onClick={() => {
                handleNodeActions('ADD_NEW_NODE_CHILD');
              }}
            ></i>
          )}

          <div style={{ width: '100%' }}>
            <p
              style={{
                ...nameStyle,
                fontSize: '13px',
                marginBottom: '0px',
                width: '100%',
                fontWeight: 'bold'
              }}
            >
              {getNodeName()}{' '}
            </p>
            <p
              style={{
                ...nameStyle,
                fontSize: '13px',
                marginBottom: '0px',
                width: '100%'
              }}
            >
              {getActionName()}
            </p>
          </div>
        </div>
      </div>
      {verifyIfNodeHasChildren() && (
        <>
          <ul>
            <DialogTreeComponent data={nodeData.nodes || {}} />
          </ul>
        </>
      )}

      <DeleteNodeConfirmationModal
        isModalOpen={modalExcludeNode}
        onModalToggle={setModalExcludeNode}
        nodeData={nodeData}
        nodeHasChildren={verifyIfNodeHasChildren()}
      />
    </>
  );
};

export default NodeTree;
